import {KullaniciGrupYetki} from './kullanici-grup-yetki';

export class KullaniciGrup {

  id: number;
  isim: string;
  pKullaniciGrupYetkiler: KullaniciGrupYetki[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get kullaniciGrupYetkiler(): KullaniciGrupYetki[] {
    return this.pKullaniciGrupYetkiler;
  }

  public set kullaniciGrupYetkiler(list: KullaniciGrupYetki[]) {
    if (list != null) {
      this.pKullaniciGrupYetkiler = list.map(t => new KullaniciGrupYetki(t));
    }
  }
}
